import { observable as Symbol_observable } from '../symbol/observable';
export function isInteropObservable(input) {
    return input && typeof input[Symbol_observable] === 'function';
}
